export default "__VITE_ASSET__1yCnd9DH__"